import { TranslationDict } from "../types";

export const enNavbar: TranslationDict = {
  bestand: "File",
  nieuw: "New",
  open: "Open",
  bewaar: "Save",
  maakOfferte: "Create offer",
  maakOverzicht: "Create overview",
  afwerking: "Finish",
  instellingen: "Settings",
  installateur: "Installer",
  afmelden: "Log out",
  klant: "Client",
  maakKlant: "Create new client",
  opties: "Options",
  project: "Project",
};
